import { render, staticRenderFns } from "./ProductBasePage.vue?vue&type=template&id=1a03d0d4&scoped=true&"
import script from "./ProductBasePage.vue?vue&type=script&lang=js&"
export * from "./ProductBasePage.vue?vue&type=script&lang=js&"
import style0 from "./ProductBasePage.vue?vue&type=style&index=0&id=1a03d0d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a03d0d4",
  null
  
)

export default component.exports